import { styled, Typography, TypographyProps } from "@mui/material";

export const StandingsKeyText = styled((props: TypographyProps) => (
  <Typography variant="bodySecondaryReg" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[600],
}));
